var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"cmpbk black--text",attrs:{"id":"home-container"}})
}
var staticRenderFns = []

export { render, staticRenderFns }